import {Alert} from "antd";
import {WarningFilled} from "@ant-design/icons";
import {GetCustomerStoreServiceOrderApiResponse} from "../../../../../../../react-query-hooks/store/services/get-store-service-order/types";
import {
  CustomerServiceOrderDrawerOrderInfoOrderDetails,
  CustomerServiceOrderDrawerOrderInfoOrderDetailsProps,
} from "./order-details";
import {CustomerServiceOrderWorkDelivery} from "../work-delivery";
import {
  ServiceOrderDrawerOrderInfoOrderTime,
  ServiceOrderDrawerOrderInfoOrderTimeProps,
} from "../../../card/drawer/order-info/order-time";
import {StyledServiceOrderDrawerOrderInfo} from "../../../card/drawer/order-info/styles";

export type CustomerServiceOrderDrawerOrderInfoProps =
  ServiceOrderDrawerOrderInfoOrderTimeProps &
    CustomerServiceOrderDrawerOrderInfoOrderDetailsProps & {
      productServiceDeliveries: GetCustomerStoreServiceOrderApiResponse["productServiceDelivery"];
      deliveryDate: string;
    };

export function CustomerServiceOrderDrawerOrderInfo({
  orderTime,
  status,
  coachName,
  deliveryInfo,
  price,
  productServiceDeliveries,
  deliveryDate,
}: CustomerServiceOrderDrawerOrderInfoProps) {
  return (
    <StyledServiceOrderDrawerOrderInfo>
      <ServiceOrderDrawerOrderInfoOrderTime orderTime={orderTime} status={status} />
      <CustomerServiceOrderDrawerOrderInfoOrderDetails
        coachName={coachName}
        deliveryInfo={deliveryInfo}
        price={price}
      />
      {status === "disputeOpened" && (
        <Alert
          type="error"
          icon={<WarningFilled />}
          showIcon
          message="Dispute in progress."
          description={
            <p style={{color: "#8C8C8C"}}>
              Dispute resolution takes 3 to 5 days. Our team will be in touch with you.
            </p>
          }
        />
      )}

      <div>
        <CustomerServiceOrderWorkDelivery
          status={status}
          productServiceDeliveries={productServiceDeliveries}
          deliveryDate={deliveryDate}
        />
      </div>
    </StyledServiceOrderDrawerOrderInfo>
  );
}
